/* KONSEI draft theme: accessible product quick view with live Shopify product information */
(function(){
'use strict';
const $=(s,r=document)=>r.querySelector(s);
const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
const modal=$('#ks-quick-view');
if(!modal)return;
const content=$('#ks-quick-content',modal);
let lastFocus=null, activeRequest=0;
const root=()=>window.Shopify?.routes?.root||'/';
const money=n=>new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format((Number(n)||0)/100);
const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const cleanImage=x=>typeof x==='string'?x:(x?.src||'');
function descData(raw){
  const doc=new DOMParser().parseFromString(raw||'','text/html');
  const p=doc.body.querySelector('p');
  const sections={};
  let key='';
  for(const n of doc.body.children){
    if(/^H[2-4]$/.test(n.tagName)){key=n.textContent.trim().toLowerCase();if(!sections[key])sections[key]=[];continue;}
    if(key){
      const items=n.matches('ul,ol')?Array.from(n.querySelectorAll('li')).map(li=>li.textContent.trim()):[n.textContent.trim()];
      sections[key].push(...items.filter(Boolean));
    }
  }
  const short=p?.textContent.trim()||doc.body.textContent.trim().slice(0,200);
  return {short,sections};
}
function sectionFind(o,needle){
 const key=Object.keys(o).find(x=>x.includes(needle));
 return key?o[key]:[];
}
function close(){
 if(modal.hidden)return;
 activeRequest++;modal.hidden=true;modal.setAttribute('aria-hidden','true');
 document.body.classList.remove('ks-modal-open');
 content.innerHTML='';
 lastFocus?.focus?.();
}
function putImage(img,photos,index){
 if(!img||!photos[index])return;
 img.src=photos[index];img.alt=img.dataset.productName||'KONSEI product';
 $$('.ks-quick-thumb',content).forEach((n,i)=>{n.setAttribute('aria-pressed',String(i===index))});
}
function bindProduct(p,photos,bamboo,initialId){
 const main=$('[data-ks-modal-image]',content),mainTitle=p.title||'KONSEI product';
 if(main)main.dataset.productName=mainTitle;
 const picker=$('[data-ks-variant]',content),price=$('[data-ks-price]',content),compare=$('[data-ks-compare]',content);
 const savings=$('[data-ks-savings]',content),button=$('[data-ks-modal-add]',content),qty=$('[data-ks-modal-qty]',content);
 const availableVariants=p.variants||[];
 function selected(){return availableVariants.find(v=>String(v.id)===String(picker?.value))||availableVariants[0]}
 function sync(){
  const v=selected();if(!v)return;
  price.textContent=money(v.price);
  const old=Number(v.compare_at_price)||0,now=Number(v.price)||0;
  compare.hidden=!(old>now);compare.textContent=old>now?money(old):'';
  savings.hidden=!(old>now);savings.textContent=old>now?Math.round(100*(old-now)/old)+'% OFF':'';
  button.disabled=!v.available;button.textContent=v.available?'Add to bag':'Sold out';
  if(bamboo){const size=/200/.test(v.title)?1:0;putImage(main,photos,size);}
 }
 $$('.ks-quick-thumb',content).forEach((node,i)=>node.addEventListener('click',()=>{
  if(bamboo&&picker&&p.variants?.length>1){
    const found=availableVariants.find(v=>i===1?/200/.test(v.title):/100/.test(v.title));
    if(found){picker.value=String(found.id);sync();return}
  }
  putImage(main,photos,i);
 }));
 if(picker){picker.value=String(initialId||availableVariants[0]?.id||'');picker.addEventListener('change',sync)}
 $$('.ks-quick-step',content).forEach(b=>b.addEventListener('click',()=>{
  qty.value=Math.max(1,Math.min(50,(parseInt(qty.value,10)||1)+Number(b.dataset.step)));
 }));
 qty?.addEventListener('change',()=>qty.value=Math.max(1,Math.min(50,parseInt(qty.value,10)||1)));
 button?.addEventListener('click',async()=>{
  const variant=selected();if(!variant||!variant.available)return;
  button.disabled=true;button.textContent='Adding…';
  try{
    const resp=await fetch(root()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variant.id,quantity:Math.max(1,Math.min(50,parseInt(qty.value,10)||1))})});
    const data=await resp.json();
    if(!resp.ok)throw new Error(data.description||'Could not add item');
    close();
    if(window.KONSEI?.refreshCart)await window.KONSEI.refreshCart();
    if(window.KONSEI?.openCart)window.KONSEI.openCart();else window.location.href='/cart';
  }catch(err){alert(err.message||'Could not add product');button.disabled=false;button.textContent='Add to bag'}
 });
 sync();
}
async function show(trigger){
 const handle=trigger.dataset.ksHandle;if(!handle)return;
 lastFocus=trigger;const serial=++activeRequest;
 modal.hidden=false;modal.setAttribute('aria-hidden','false');document.body.classList.add('ks-modal-open');
 content.innerHTML='<div class="ks-quick-loading" role="status">Loading product details…</div>';
 $('.ks-quick-dialog',modal)?.focus();
 try{
  const res=await fetch(root()+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'});
  if(!res.ok)throw new Error('Could not load product');
  const p=await res.json();if(serial!==activeRequest)return;
  const b100=trigger.dataset.ksBamboo100||'',b200=trigger.dataset.ksBamboo200||'';
  const bamboo=Boolean(b100);
  const imgs=bamboo?[b100,b200].filter(Boolean):(p.images||[]).map(cleanImage).filter(Boolean).slice(0,8);
  if(!imgs.length&&p.featured_image)imgs.push(cleanImage(p.featured_image));
  const details=descData(p.description||p.body_html||'');
  const items=sectionFind(details.sections,'ingredient');
  const benefits=sectionFind(details.sections,'benefit');
  const directions=sectionFind(details.sections,'how to use');
  const other=sectionFind(details.sections,'precaution');
  const buildList=xs=>xs.length?'<ul>'+xs.map(x=>'<li>'+esc(x)+'</li>').join('')+'</ul>':'<p>See product label for complete information.</p>';
  const accord=[
    items.length?'<details open><summary>Ingredient highlights</summary>'+buildList(items)+'</details>':'',
    benefits.length?'<details><summary>Benefits</summary>'+buildList(benefits)+'</details>':'',
    directions.length?'<details><summary>How to use</summary>'+buildList(directions)+'</details>':'',
    other.length?'<details><summary>Precautions</summary>'+buildList(other)+'</details>':'',
    '<details><summary>Shipping &amp; payment</summary><p>Delivery options and payment methods are shown at checkout. Read the <a href="/pages/shipping-policy">Shipping Policy</a> for free-shipping eligibility.</p></details>'
  ].join('');
  const v0=p.variants?.[0];
  const chosen=trigger.closest('[data-konsei-product-card]')?.querySelector('.ks-card-select')?.value||v0?.id;
  content.innerHTML='<div class="ks-quick-media"><div class="ks-quick-thumbs">'+imgs.map((url,i)=>'<button type="button" class="ks-quick-thumb" aria-label="View product image '+(i+1)+'" aria-pressed="'+(i===0)+'"><img loading="lazy" src="'+esc(url)+'" alt=""></button>').join('')+'</div><div class="ks-quick-main"><img src="'+esc(imgs[0]||'')+'" data-ks-modal-image alt="'+esc(p.title)+'">'+(bamboo?'<span class="ks-concept-notice">Bamboo packaging concept</span>':'')+'</div></div>'+
  '<div class="ks-quick-info"><p class="ks-quick-eyebrow">'+esc(p.type||'KONSEI COSMETICS')+' · KONSEI</p><h2 id="ks-quick-title">'+esc(p.title)+'</h2><p class="ks-quick-desc">'+esc(details.short)+'</p>'+
  '<div class="ks-quick-price"><strong data-ks-price></strong><s data-ks-compare hidden></s><span data-ks-savings hidden></span></div>'+
  '<div class="ks-quick-variant"><label for="ks-quick-variant-select">Choose size / option</label><select id="ks-quick-variant-select" data-ks-variant>'+((p.variants||[]).map(v=>'<option value="'+esc(v.id)+'">'+esc(v.title)+' · '+money(v.price)+(v.available?'':' · Sold out')+'</option>').join(''))+'</select></div>'+
  '<div class="ks-quick-purchase"><div class="ks-quick-qty"><button class="ks-quick-step" data-step="-1" type="button" aria-label="Decrease quantity">−</button><input data-ks-modal-qty type="number" min="1" max="50" value="1" aria-label="Quantity"><button class="ks-quick-step" data-step="1" type="button" aria-label="Increase quantity">+</button></div><button type="button" class="ks-quick-add" data-ks-modal-add>Add to bag</button></div>'+
  '<a class="ks-quick-wa" target="_blank" rel="noopener" href="https://wa.me/918328589323?text='+encodeURIComponent('Hello KONSEI, I have a question about '+p.title)+'">Personal consultation on WhatsApp ↗</a>'+
  '<div class="ks-quick-details">'+accord+'</div><a class="ks-full-details" href="/products/'+encodeURIComponent(handle)+'">View full product details →</a></div>';
  bindProduct(p,imgs,bamboo,chosen);
 }catch(e){
  if(serial!==activeRequest)return;
  content.innerHTML='<div class="ks-quick-error"><p>Product details could not load.</p><a href="/products/'+encodeURIComponent(handle)+'">Open product page →</a></div>';
 }
}
document.addEventListener('click',e=>{
 const trigger=e.target.closest('[data-ks-quick-view]');if(trigger){e.preventDefault();show(trigger);return;}
 if(e.target.closest('[data-ks-modal-close]')||(e.target===modal)){e.preventDefault();close()}
});
document.addEventListener('keydown',e=>{if(modal.hidden)return;if(e.key==='Escape')close();if(e.key==='Tab'){
 const focusable=$$('a[href],button:not([disabled]),select:not([disabled]),input:not([disabled])',modal).filter(el=>el.offsetParent!==null);
 if(!focusable.length)return;
 const first=focusable[0],last=focusable[focusable.length-1];
 if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
 else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
}});
document.addEventListener('change',e=>{
 const select=e.target.closest('.ks-card-select');if(!select)return;
 const card=select.closest('[data-konsei-product-card]');const o=select.selectedOptions[0];if(!card||!o)return;
 const image=$('[data-konsei-card-image]',card),price=$('[data-card-price]',card),compare=$('[data-card-compare]',card),discount=$('[data-card-discount]',card),bag=$('[data-konsei-card-add]',card),input=$('[data-konsei-card-variant-id]',card);
 if(input)input.value=o.value;if(image&&o.dataset.image)image.src=o.dataset.image;
 if(price)price.textContent=o.dataset.price||'';
 if(compare){compare.textContent=o.dataset.compare||'';compare.hidden=!o.dataset.compare}
 const before=Number(o.dataset.compareCents||0),now=Number(o.dataset.priceCents||0);
 if(discount){discount.textContent=before>now?Math.round(100*(before-now)/before)+'% OFF':'';discount.hidden=!(before>now)}
 if(bag){bag.disabled=o.dataset.available!=='true';bag.textContent=bag.disabled?'Sold out':'Add to bag'}
});
})();